import '.ap{border-radius:1.25rem;}.ssr-plugin'
import '.b1{overflow:hidden;}.ssr-plugin'
import '.hp{border:var(--border-default);}.ssr-plugin'
import '.hq{min-height:420px;}.ssr-plugin'
import '.ai{height:100%;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.hr{color:var(--content-secondary);}.ssr-plugin'
import '.hs{font-size:14px;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

const ALLOWED_EMBED_HOSTS = new Set([
  'www.slideshare.net',
  'slideshare.net',
  'www.youtube.com',
  'youtube.com',
  'player.vimeo.com',
  'vimeo.com',
  'docs.google.com',
])

function isAllowedEmbedUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url)
    return ALLOWED_EMBED_HOSTS.has(hostname)
  } catch {
    return false
  }
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  if (!isAllowedEmbedUrl(src)) {
    return (
      <styled.div className={`${className} ap b1 hp hq ai d z ad`}
        style={{
          ...style,
        }}
      >
        <p className="hr hs">
          Embed URL not allowed.
        </p>
      </styled.div>
    )
  }

  return (
    <styled.div className={`${className} ap b1 hp hq ai d e`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        sandbox="allow-scripts allow-same-origin allow-presentation"
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
